export let routes = [
  {
    path: '/x3-side-prestore-campus',
    name: 'x3-side-prestore-campus',
    component: () => import('@x3/js/side/prestore-campus/prestore-campus.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsPrestoreCampus(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-prestore-campus',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};